import {
  MutationResponse,
  ProducerManagementReferralCode,
  ReferredApplicantData,
  SuccessResponse,
} from "config";
import { getApolloClient } from "store/apollo";
import { assertDefined } from "utils/error";

import { gql } from "@apollo/client";

interface ICreateApplicationReferralData {
  createApplicationReferral: SuccessResponse;
}

export interface ICreateApplicationReferralInput {
  referralCode: ProducerManagementReferralCode;
  externalId?: ReferredApplicantData["external_id"];
}

export const createApplicationReferralMutation: MutationResponse<
  ICreateApplicationReferralInput,
  ICreateApplicationReferralData
> = async (input: ICreateApplicationReferralInput) => {
  const client = getApolloClient();

  const mutation = gql`
    mutation CreateApplicationReferral($input: CreateApplicationReferralInput!) {
      createApplicationReferral(input: $input) {
        response {
          success
        }
      }
    }
  `;

  const { data } = await client.mutate<ICreateApplicationReferralData>({
    mutation,
    variables: {
      input,
    },
  });
  return { data: assertDefined(data) };
};
